import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=f8e5562c&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=js&"
export * from "./ReadMore.vue?vue&type=script&lang=js&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=f8e5562c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e5562c",
  null
  
)

export default component.exports